import "./raffle";
import "./swiper";

jQuery(document).ready(function ($) {
  /* Hamburger Menu: Mobile */
  $(".hamburger-menu").click(function () {
    $(this).toggleClass("open");
    $(".primary-nav").toggle();
  });

  $(".button-open-menu").click(function () {
    $(".mobile-overlay").toggleClass("active");
    $(".mobile-nav").toggleClass("active");
  });

  $(".button-close-menu").click(function () {
    $(".mobile-overlay").toggleClass("active");
    $(".mobile-nav").toggleClass("active");
  });

  /*SUB MENU FOR MOBILE*/
  $(".mobile-nav .menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("show-sub-menu");
  });

  /*START ACCORDION*/
  var checkAccordionAvailability = $(".ns-accordion");
  if (checkAccordionAvailability) {
    $("#toggle-accordion .open").click(function () {
      $(this).parent().addClass("active");
      $(".accordion, .panel").addClass("active");
    });

    $("#toggle-accordion .close").click(function () {
      $(this).parent().removeClass("active");
      $(".accordion, .panel").removeClass("active");
    });

    $("main").on("click", ".accordion:not(.active)", function () {
      $(this).addClass("active");
      $(this).siblings().addClass("active");
      console.log("abriendo el panel");
    });

    $("main").on("click", ".accordion.active", function () {
      $(this).removeClass("active");
      $(this).siblings().removeClass("active");
      console.log("cerrando el panel");
    });
  }
  /*FINISH ACCORDION*/

  /*START DISCLAIMER*/
  var checkDisclaimerAvailability = $(".disclaimer");
  if (checkDisclaimerAvailability) {
    function createCookie(name, value, days) {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toGMTString();
      } else var expires = "";

      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    function eraseCookie(name) {
      createCookie(name, "", -1);
    }

    $(document).ready(function () {
      if (readCookie("show_popup") == "no") {
        $(".disclaimer").hide();
      }

      $(".disclaimer-agree a").click(function (e) {
        e.preventDefault();
        $(".disclaimer").hide();
        eraseCookie("show_popup");
        createCookie("show_popup", "no", "7");
      });
    });
  }
  /*FINISH DISCLAIMER*/

  /* Setup Wistia video handling to pause other videos when one starts playing */
  function setupWistiaVideos() {
    window._wq = window._wq || [];
    _wq.push({
      id: "_all",
      onReady: function (video) {
        // for all existing and future videos, run this function
        video.bind("play", function () {
          // when one video plays, iterate over all the videos and pause each,
          // unless it's the video that just started playing.
          var allVideos = Wistia.api.all();
          for (var i = 0; i < allVideos.length; i++) {
            if (allVideos[i].hashedId() !== video.hashedId()) {
              allVideos[i].pause();
            }
          }
        });
      },
    });
  }

  // Initialize Wistia video handling
  setupWistiaVideos();

  // Slider functionality
  let slideIndex = 1;
  showSlides(slideIndex);

  $(".prev").click(function () {
    plusSlides(-1);
  });

  $(".next").click(function () {
    plusSlides(1);
  });

  function plusSlides(n) {
    showSlides((slideIndex += n));
  }

  function currentSlide(n) {
    showSlides((slideIndex = n));
  }

  function showSlides(n) {
    let i;
    let slides = $(".mySlides");
    let dots = $(".dot");
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    slides.hide();
    dots.removeClass("active");
    slides.eq(slideIndex - 1).show();
    dots.eq(slideIndex - 1).addClass("active");
  }

  // Initialize dot click handlers
  $(".dot").click(function () {
    currentSlide($(this).index() + 1);
  });

  /* Show page once js has loaded */
  $("body").removeClass("loading-js");

  // RESOURCES PAGE ACCORDION
  $(".ns-with-navbar__nav__button").on("click", function () {
    const expanded = $(this).attr("aria-expanded") === "true";

    $(this).attr("aria-expanded", !expanded);

    const targetList = $("#" + $(this).attr("aria-controls"));

    if (expanded) {
      targetList.css("max-height", "0");
      setTimeout(function () {
        targetList.removeClass("active");
      }, 300);
    } else {
      targetList.addClass("active");
      targetList.css("max-height", targetList[0].scrollHeight + "px");
    }
  });

  // VOTE BY PAGES ACCORDION
  $(".ns-vote-by__nav__button").on("click", function () {
    const expanded = $(this).attr("aria-expanded") === "true";

    $(this).attr("aria-expanded", !expanded);

    const targetList = $("#" + $(this).attr("aria-controls"));

    if (expanded) {
      targetList.css("max-height", "0");
      setTimeout(function () {
        targetList.removeClass("active");
      }, 300);
    } else {
      targetList.addClass("active");
      targetList.css("max-height", targetList[0].scrollHeight + "px");
    }
  });
});

/*START NS-TWO-PROPOSALS FAQ ACCORDION*/
jQuery(document).ready(function ($) {
  $(".ns-two-proposals__faq-question").on("click", function () {
    const $button = $(this);
    const $faqItem = $button.closest(".ns-two-proposals__faq-item");
    const $answer = $faqItem.find(".ns-two-proposals__faq-answer");

    const isExpanded = $button.attr("aria-expanded") === "true";

    $button
      .closest(".ns-two-proposals__faq")
      .find(".ns-two-proposals__faq-question")
      .not($button)
      .attr("aria-expanded", "false")
      .closest(".ns-two-proposals__faq-item")
      .removeClass("is-open")
      .find(".ns-two-proposals__faq-answer")
      .attr("aria-hidden", "true")
      .slideUp(300);

    if (isExpanded) {
      $button.attr("aria-expanded", "false");
      $faqItem.removeClass("is-open");
      $answer.attr("aria-hidden", "true").slideUp(300);
    } else {
      $button.attr("aria-expanded", "true");
      $faqItem.addClass("is-open");
      $answer.attr("aria-hidden", "false").slideDown(300);
    }
  });
});

/*START NS-JOIN-THE-MOVEMENT PROFILE BADGE GENERATOR*/
jQuery(document).ready(function ($) {
  $(".ns-join-the-movement").each(function () {
    const $section = $(this);
    const uploadArea = $section.find("#uploadArea")[0];
    const fileInput = $section.find("#imageUpload")[0];
    const uploadedImage = $section.find("#uploadedImage")[0];
    const controls = $section.find("#controls")[0];
    const canvas = $section.find("#previewCanvas")[0];
    const ctx = canvas.getContext("2d");
    const downloadBtn = $section.find("#downloadBtn")[0];
    const badgeImage = $section.find("#badgeImage")[0];

    let currentImage = null;
    let zoom = 100;
    let posX = 50;
    let posY = 50;

    // Initialize canvas with badge image
    function initializeCanvas() {
      const canvasSize = window.innerWidth <= 768 ? 200 : 300;
      canvas.width = canvasSize;
      canvas.height = canvasSize;

      // Clear canvas
      ctx.clearRect(0, 0, canvasSize, canvasSize);

      // Always draw the badge frame
      if (badgeImage && badgeImage.complete) {
        ctx.drawImage(badgeImage, 0, 0, canvasSize, canvasSize);
      }
    }

    // Upload area click handler
    uploadArea.addEventListener("click", function () {
      fileInput.click();
    });

    // Upload area keyboard support
    uploadArea.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        fileInput.click();
      }
    });

    // Drag and drop handlers
    uploadArea.addEventListener("dragover", function (e) {
      e.preventDefault();
      uploadArea.classList.add("drag-over");
    });

    uploadArea.addEventListener("dragleave", function (e) {
      e.preventDefault();
      uploadArea.classList.remove("drag-over");
    });

    uploadArea.addEventListener("drop", function (e) {
      e.preventDefault();
      uploadArea.classList.remove("drag-over");
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        handleFileUpload(files[0]);
      }
    });

    // File input change handler
    fileInput.addEventListener("change", function (e) {
      if (e.target.files.length > 0) {
        handleFileUpload(e.target.files[0]);
      }
    });

    // Control handlers with ARIA updates
    $section.find("#zoomSlider").on("input", function () {
      zoom = parseInt(this.value);
      $section.find("#zoomValue").text(zoom + "%");
      $(this).attr("aria-valuenow", zoom);
      $(this).attr("aria-valuetext", zoom + "%");
      updatePreview();
    });

    $section.find("#posXSlider").on("input", function () {
      posX = parseInt(this.value);
      $section.find("#posXValue").text(posX + "%");
      $(this).attr("aria-valuenow", posX);
      $(this).attr("aria-valuetext", posX + "%");
      updatePreview();
    });

    $section.find("#posYSlider").on("input", function () {
      posY = parseInt(this.value);
      $section.find("#posYValue").text(posY + "%");
      $(this).attr("aria-valuenow", posY);
      $(this).attr("aria-valuetext", posY + "%");
      updatePreview();
    });

    // Download button handler
    downloadBtn.addEventListener("click", function () {
      downloadImage();
    });

    function handleFileUpload(file) {
      if (!file.type.startsWith("image/")) {
        alert("Please upload an image file.");
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
        currentImage = new Image();
        currentImage.onload = function () {
          uploadedImage.src = e.target.result;
          uploadedImage.style.display = "block";
          uploadArea.querySelector(".upload-placeholder").style.display =
            "none";
          controls.style.display = "block";
          downloadBtn.disabled = false;
          downloadBtn.setAttribute("aria-disabled", "false");
          updatePreview();
        };
        currentImage.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    function updatePreview() {
      const canvasSize = window.innerWidth <= 768 ? 200 : 300;
      canvas.width = canvasSize;
      canvas.height = canvasSize;

      // Clear canvas
      ctx.clearRect(0, 0, canvasSize, canvasSize);

      // If there's a user image, draw it first as a perfect circle (underneath)
      if (currentImage) {
        // Calculate scale to fit image in full canvas circle
        const radius = (canvasSize / 2) * 0.98; // Make radius slightly smaller
        const baseScale = Math.max(
          canvasSize / currentImage.width,
          canvasSize / currentImage.height
        );
        const scale = baseScale * (zoom / 100);

        // Calculate scaled dimensions
        const scaledWidth = currentImage.width * scale;
        const scaledHeight = currentImage.height * scale;

        // Calculate position based on sliders
        const centerX = canvasSize / 2;
        const centerY = canvasSize / 2;

        // Calculate max offset
        const maxOffsetX = Math.max(0, (scaledWidth - canvasSize) / 2);
        const maxOffsetY = Math.max(0, (scaledHeight - canvasSize) / 2);

        // Convert slider values (0-100) to offset (-maxOffset to +maxOffset)
        const offsetX = (posX - 50) * (maxOffsetX / 50);
        const offsetY = (posY - 50) * (maxOffsetY / 50);

        // Final position
        const x = centerX - scaledWidth / 2 + offsetX;
        const y = centerY - scaledHeight / 2 + offsetY;

        // Save context for clipping
        ctx.save();

        // Create perfect circular clipping path
        ctx.beginPath();
        ctx.arc(canvasSize / 2, canvasSize / 2, radius, 0, Math.PI * 2);
        ctx.clip();

        // Draw user image as perfect circle
        ctx.drawImage(currentImage, x, y, scaledWidth, scaledHeight);

        // Restore context
        ctx.restore();
      }

      // Draw the badge frame on top (will be replaced with transparent SVG later)
      if (badgeImage && badgeImage.complete) {
        ctx.drawImage(badgeImage, 0, 0, canvasSize, canvasSize);
      }
    }

    function downloadImage() {
      if (!currentImage) return;

      // Create high-res canvas
      const downloadCanvas = document.createElement("canvas");
      const downloadCtx = downloadCanvas.getContext("2d");
      const size = 1024;

      downloadCanvas.width = size;
      downloadCanvas.height = size;

      // Clear canvas
      downloadCtx.clearRect(0, 0, size, size);

      // Draw user image first as a perfect circle (underneath)
      if (currentImage) {
        // Use same calculation logic as preview but scaled up
        const radius = (size / 2) * 0.98; // Make radius slightly smaller
        const baseScale = Math.max(
          size / currentImage.width,
          size / currentImage.height
        );
        const scale = baseScale * (zoom / 100);

        // Calculate scaled dimensions
        const scaledWidth = currentImage.width * scale;
        const scaledHeight = currentImage.height * scale;

        // Calculate position based on sliders
        const centerX = size / 2;
        const centerY = size / 2;

        // Calculate max offset
        const maxOffsetX = Math.max(0, (scaledWidth - size) / 2);
        const maxOffsetY = Math.max(0, (scaledHeight - size) / 2);

        // Convert slider values to offset
        const offsetX = (posX - 50) * (maxOffsetX / 50);
        const offsetY = (posY - 50) * (maxOffsetY / 50);

        // Final position
        const x = centerX - scaledWidth / 2 + offsetX;
        const y = centerY - scaledHeight / 2 + offsetY;

        // Save context for clipping
        downloadCtx.save();

        // Create perfect circular clipping path
        downloadCtx.beginPath();
        downloadCtx.arc(size / 2, size / 2, radius, 0, Math.PI * 2);
        downloadCtx.clip();

        // Draw user image as perfect circle
        downloadCtx.drawImage(currentImage, x, y, scaledWidth, scaledHeight);

        // Restore context
        downloadCtx.restore();
      }

      // Draw the badge frame on top (will be replaced with transparent SVG later)
      if (badgeImage && badgeImage.complete) {
        downloadCtx.drawImage(badgeImage, 0, 0, size, size);
      }

      // Download the image
      downloadCanvas.toBlob(function (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "profile-picture.png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      });
    }

    // Initialize canvas on page load
    initializeCanvas();

    // Load badge image if available
    if (badgeImage) {
      badgeImage.onload = function () {
        initializeCanvas();
      };
      // If image is already loaded
      if (badgeImage.complete) {
        initializeCanvas();
      }
    }

    // Handle window resize to update canvas size
    $(window).on("resize", function () {
      if (currentImage) {
        updatePreview();
      } else {
        initializeCanvas();
      }
    });

    // Header Photos Download Functionality
    $(".photo-download-button").on("click", function (e) {
      e.preventDefault();
      const imageUrl = $(this).data("image-url");
      const imageName = $(this).data("image-name");

      // Create a temporary link and trigger download
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = imageName || "header-photo.jpg";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch((error) => {
          console.error("Error downloading image:", error);
          // Fallback: open in new tab
          window.open(imageUrl, "_blank");
        });
    });

    // Download All Photos Functionality
    $("#downloadAllPhotos").on("click", function (e) {
      e.preventDefault();
      const buttons = $section.find(".photo-download-button");

      buttons.each(function (index) {
        const imageUrl = $(this).data("image-url");
        const imageName = $(this).data("image-name");

        // Stagger downloads slightly to avoid browser blocking
        setTimeout(() => {
          fetch(imageUrl)
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.style.display = "none";
              a.href = url;
              a.download = imageName || `header-photo-${index + 1}.jpg`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            })
            .catch((error) => {
              console.error("Error downloading image:", error);
            });
        }, index * 300); // 300ms delay between each download
      });
    });

    // Share to X (Twitter) Functionality
    $("#shareToX").on("click", function (e) {
      e.preventDefault();
      const shareMessage = $(this).data("share-message");

      if (shareMessage) {
        // Encode the message for URL
        const encodedMessage = encodeURIComponent(shareMessage);
        // Open X share window
        const shareUrl = `https://twitter.com/intent/tweet?text=${encodedMessage}`;
        window.open(shareUrl, "_blank", "width=550,height=420");
      }
    });
  });
});
